import React from 'react';
import { TicketCardContent } from '../../../detail/components/ticket-card/ticketCard';
import SessionDate from './Date';
import css from '../../styles.module.css';

export default function SessionRate({ session, rate }) {
    return (
        <TicketCardContent className={`order-summary-content `}>
            <div className={css['summary-ticket-item']}>
                <SessionDate date={session} />
            </div>
            <div className={css['summary-ticket-subitem']}>{rate}</div>
        </TicketCardContent>
    );
}
